import * as React from "react";
import {
  Grid,
  Modal,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  capitalize,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { formatToUsDate, getDateTime } from "../../../utils/DateHelper";

interface Props {
  selectedEncounterBillingLogs: any;
  showEncounterHistory: boolean;
  closeEncounterHistoryModal: any;
}

const EncounterHistory: React.FC<Props> = ({
  selectedEncounterBillingLogs,
  showEncounterHistory,
  closeEncounterHistoryModal,
}) => {
  return (
    <Modal
      open={showEncounterHistory}
      className={"modal-primary"}
      onClose={closeEncounterHistoryModal}
    >
      <div className="paper" style={{ width: "950px", height: "90vh" }}>
        <div className="paperInner">
          <Grid container>
            <Grid item xs={12}>
              <div className={`main-header`} style={{ marginBottom: "0px" }}>
                <span>Encounter History</span>
                <span id="dismiss-button" onClick={closeEncounterHistoryModal}>
                  <ClearIcon sx={{ width: 30, height: 30 }} />
                </span>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="content" style={{ padding: "0 0 40px 0" }}>
                <TableContainer sx={{ height: "75vh" }}>
                  <Table stickyHeader>
                    <TableHead
                      sx={{
                        boxShadow: "0px 4px 4px 0px #00000040",
                        backgroundColor: "#fff",
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                      }}
                    >
                      <TableRow
                        sx={{
                          "& td, & th": {
                            borderBottom: "none",
                          },
                        }}
                      >
                        <TableCell
                          align="left"
                          sx={{ paddingLeft: "40px", width: "60px" }}
                        >
                          Date
                        </TableCell>
                        <TableCell sx={{ width: "100px" }}></TableCell>
                        <TableCell align="left" sx={{ width: "180px" }}>
                          Actor
                        </TableCell>
                        <TableCell align="left" sx={{ paddingRight: "40px" }}>
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedEncounterBillingLogs?.map((encounterLog) => (
                        <TableRow
                          sx={{ "& td, & th": { borderBottom: "none" } }}
                        >
                          <TableCell align="left" sx={{ paddingLeft: "40px" }}>
                            {formatToUsDate(encounterLog.created_at)}
                          </TableCell>
                          <TableCell>
                            {getDateTime(encounterLog.created_at)}
                          </TableCell>
                          <TableCell align="left" sx={{ width: "180px" }}>
                            {encounterLog.name}
                          </TableCell>
                          <TableCell align="left" sx={{ paddingRight: "40px" }}>
                            {capitalize(encounterLog.action)}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </Modal>
  );
};

export default EncounterHistory;
